import React from "react";
import { Skeleton } from "@components/Skeleton/Skeleton";

interface ITabsSkeletonProps {
  count?: number;
}

export const TabsSkeleton: React.FC<
  React.PropsWithChildren<ITabsSkeletonProps>
> = ({ children, count = 2 }) => (
  <>
    <div className="relative mb-8 flex w-full flex-row gap-3 overflow-x-auto overflow-y-hidden">
      {Array(count)
        .fill(0)
        .map((_, index) => (
          <Skeleton key={index} variant="rounded" className="h-9 w-36" />
        ))}
    </div>
    {children}
  </>
);
